"use client";

import { FC, Fragment, MouseEvent } from "react";
import styles from "./style.module.scss";
import { IFAQ } from "@/types/IFAQ";

const FAQ: FC<{ faq: IFAQ[] }> = ({ faq }) => {
  function open(e: MouseEvent<HTMLElement>) {
    e.currentTarget.nextElementSibling?.classList.toggle(styles.open);
    e.currentTarget.classList.toggle(styles.open);
  }

  return (
    <dl className={styles.dl}>
      {faq.map((e, index) => (
        <Fragment key={index}>
          <dt
            tabIndex={0}
            onClick={open}
            onKeyDown={(e) => {
              if (e.key == " " || e.code == "Space" || e.keyCode == 32) {
                e.preventDefault();
                e.currentTarget.nextElementSibling?.classList.toggle(
                  styles.open,
                );
                e.currentTarget.classList.toggle(styles.open);
              }
            }}
          >
            {e.question}
          </dt>
          <dd>
            <p>{e.answer}</p>
          </dd>
        </Fragment>
      ))}
    </dl>
  );
};

export default FAQ;
